/**
 * @generated SignedSource<<39727460c7fef85f5d714675cff46cb0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RecordListenProgressInput = {
  durationSeconds: number;
  episodeId: string;
  progressSeconds: number;
  topicSlug: string;
};
export type GlobalPlayerRecordListenProgressMutation$variables = {
  input: RecordListenProgressInput;
};
export type GlobalPlayerRecordListenProgressMutation$data = {
  readonly recordListenProgress: {
    readonly listenProgress: {
      readonly completed: boolean;
      readonly durationSeconds: number;
      readonly listenedAt: any;
      readonly progressSeconds: number;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly field: string | null | undefined;
      readonly message: string;
    }>;
  };
};
export type GlobalPlayerRecordListenProgressMutation = {
  response: GlobalPlayerRecordListenProgressMutation$data;
  variables: GlobalPlayerRecordListenProgressMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RecordListenProgressPayload",
    "kind": "LinkedField",
    "name": "recordListenProgress",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ListenProgress",
        "kind": "LinkedField",
        "name": "listenProgress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "progressSeconds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "durationSeconds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "listenedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GlobalPlayerRecordListenProgressMutation",
    "selections": (v1/*: any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GlobalPlayerRecordListenProgressMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0954e7656a78d2a743fa9359059bdd6f",
    "id": null,
    "metadata": {},
    "name": "GlobalPlayerRecordListenProgressMutation",
    "operationKind": "mutation",
    "text": "mutation GlobalPlayerRecordListenProgressMutation(\n  $input: RecordListenProgressInput!\n) {\n  recordListenProgress(input: $input) {\n    listenProgress {\n      progressSeconds\n      durationSeconds\n      completed\n      listenedAt\n    }\n    userErrors {\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "76da98b613ca0233581a059d76a17d62";

export default node;
